export const shareEn = {
  boardSharing: 'Share this board',
  title: 'Setup board sharing for',
  turnOn: 'Turn on access to this board by link',
  publicLink: 'Public link to the board',
  theme: 'Display theme',
  lightTheme: 'Light theme',
  darkTheme: 'Dark theme',
  lang: 'Language',
  background: 'Choose background or upload new image',
  ru: 'Russian',
  en: 'English',
  addBg: 'Add new background image',
  guest: 'Guest',
  incorrectLink: 'This link is not valid',
  searchBoard: 'Search this board',
  help: 'This generates sharing link that provides guest access to this board.',
  accessLabel: 'Available by link',
  accessReadOnly: 'Read-only access',
  accessChatOnly: 'Post messages in chats',
  accessAddTasks: 'Add tasks and post messages',
  taskStatsHint: (unseen: number, total: number) =>
    `Task messages: total ${total}, unseen ${unseen}`,
  sharedWithMe: 'Shared with me',
  deleteFromList: 'Delete from this list',
  boardNameFallback: 'Board',
  allowCommenting: 'Allow commenting in chats',
  allowCreateTasks: 'Allow create new tasks',
  allowAllColumns: 'Show all columns in this board',
  poweredBy: 'Powered by',
  nothingToShow: 'There is nothing to show in this board'
}

export const shareRu: typeof shareEn = {
  boardSharing: 'Доступ по ссылке',
  title: 'Настройка доступа для',
  turnOn: 'Включить доступ по ссылке для этой доски',
  publicLink: 'Ссылка на доску',
  theme: 'Тема отображения доски',
  lightTheme: 'Светлая тема',
  darkTheme: 'Тёмная тема',
  lang: 'Язык интерфейса доски',
  background: 'Выберите фон доски или загрузите новый',
  ru: 'Русский',
  en: 'Английский',
  addBg: 'Добавить новое изображение для фона',
  guest: 'Гость',
  incorrectLink: 'Эта ссылка недействительна',
  searchBoard: 'Поиск по доске',
  help: 'Будет сгенерирована ссылка, перейдя по которой можно получить Гостевой доступ к доске.',
  accessLabel: 'Права доступа по ссылке',
  accessReadOnly: 'Только просмотр задач доски',
  accessChatOnly: 'Просмотр и отправка сообщений',
  accessAddTasks: 'Создание задач и общение в чате',
  taskStatsHint: (unseen: number, total: number) =>
    `Сообщений в чате: всего ${total}, новых ${unseen}`,
  sharedWithMe: 'Доступно по ссылке',
  deleteFromList: 'Удалить из списка',
  boardNameFallback: 'Доска',
  allowCommenting: 'Разрешить комментирование в чате',
  allowCreateTasks: 'Разрешить создание задач',
  allowAllColumns: 'Показывать все колонки в доске',
  poweredBy: 'Реализовано на',
  nothingToShow: 'На доске нет элементов для отображения'
}
